import React from "react";
import {
  SessionService,
  Auth0Service,
  LocalStorageService,
  UserService,
  CacheStorageService
} from "../../../services";
import { useTranslation } from "react-i18next";
import { Buffer } from "buffer";
import LoginView from "../../views/login/login.view";
import { ModalUtil } from "../../pures";

/**
 * @class LoginAction
 * @extends {React.Component}
 * @status no delete
 * @description determines the action for the login functionality
 */
class LoginAction extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    loading: false,
    email: "",
    password: "",
    resetEmail: "",
    newEmail: "",
    newPassword: "",
    repeatNewPassword: "",
    loginAttepmtsCount: 0,
    templateRendering: "login", //Templates: login, register, forgotPassword
    loginSelected: "login-button-signin-signup-selected",
    hideTemplatesInvitedColaborator: false,
    registerSelected: "",
    errorForm: false,
    errorMessage: "",
    successForm: false,
    successMessage: "",
    loginShowPasswordIcon: "login-input-show-password-icon-desactive",
    loginShowPasswordRegisterIcon: "login-input-show-password-icon-desactive",
    loginShowPasswordRepeatRegisterIcon:
      "login-input-show-password-icon-desactive",
  };

  auth0Service = new Auth0Service();
  localStorageService = new LocalStorageService();
  sessionService = new SessionService(process.env.REACT_APP_ETICKET_API);
  userService = new UserService(process.env.REACT_APP_ETICKET_API)
  modalUtil = new ModalUtil()

  /**
   * @author Alan Aguilar
   * @description ComponentDidMount method executed when the page is loaded for the first time
   * @updatedDate 26-08-2021
   * @memberof LoginAction
   */
  async componentDidMount() {

    let location = window.location.href;
    let isACustomPath = '?' + location.split("?")[1];
    let params = new URLSearchParams(isACustomPath)
    if (location && isACustomPath !== undefined) {
      if (params.get('email')) {
        this.setState({
          email: params.get('email'),
        });
      }
      if (params.get('registered') === 'true' && params.get('collaborator') === 'true') {
        if (params.get('email')) {
          let cipheredEmail = Buffer.from(params.get('email'), 'base64').toString('ascii')
          this.setState({
            email: cipheredEmail,
          });
        } if (params.get('password')) {
          let cipheredPassword = Buffer.from(params.get('password'), 'base64').toString('ascii')
          this.setState({
            password: cipheredPassword,
          });
        }
        this.setState({ hideTemplatesInvitedColaborator: true });
        window.history.pushState("", document.title, window.location.pathname);
      } else if (params.get('registered') === 'true' && params.get('newClient') === 'true') {
        if (params.get('email')) {
          let cipheredEmail = Buffer.from(params.get('email'), 'base64').toString('ascii')

          let user = await this.userService.getUserEmailVerificationStatus(cipheredEmail)

          if (user && user.data && user.data.emailVerified === true) {
            this.setState({
              email: cipheredEmail,
            });
          }
          else {
            let cipheredEmail = Buffer.from(params.get('email'), 'base64').toString('ascii')
            let update = await this.userService.updateUserEmailVerificationStatus(cipheredEmail)
            user = await this.userService.getUserEmailVerificationStatus(cipheredEmail)
            if (user && user.data && user.data.emailVerified === true) {
              this.setState({
                email: cipheredEmail,
              });
            }
          }

        } if (params.get('password')) {
          let cipheredPassword = Buffer.from(params.get('password'), 'base64').toString('ascii')
          this.setState({
            password: cipheredPassword,
          });
        }
        this.setState({ hideTemplatesInvitedColaborator: true });
        window.history.pushState("", document.title, window.location.pathname);
      } else if (params.get('newRegister') === "true") {
        this.setState({ templateRendering: "register" });
        window.history.pushState("", document.title, window.location.pathname);
      } else if (params.get("promotion") === "true") {
        this.localStorageService.setLocalStorageItem("promotion", true);
        if (params.get('email')) {
          this.setState({
            newEmail: params.get('email'),
            templateRendering: "register",
          });
        }
      }
    }
  }

  /**
   * @author Alan Aguilar
   * @description Handler method for LogIn an user in hibou.legal
   * @updatedDate 29-04-2022
   * @status no delete
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleLogin = async (e) => {

    e.preventDefault();
    this.setState({ loading: true });
    let { email, password } = this.state;

    email = email.trim().toLowerCase();
    password = password.trim();

    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.localStorageService.setLocalStorageItem('timezone', timezone)
      let sessionLoginToken = await this.sessionService.sessionLogin(email, password);

      if (sessionLoginToken && Number(sessionLoginToken.statusCode) === 200) {
        const cacheStorageService = new CacheStorageService()
        await cacheStorageService.clearCache()

        this.localStorageService.setLocalStorageItem("token", sessionLoginToken.data);
        return window.location.reload();
      } else if (sessionLoginToken && sessionLoginToken.statusCode === 401) {
        let { loginAttepmtsCount } = this.state;
        let count = loginAttepmtsCount + 1;
        this.setState({ loginAttepmtsCount: count, loading: false });
        return false;
      }
    } catch (err) {
      console.log(err);
      this.modalUtil.showModal('error', this.props.t("login.action.errorReload"), this.props.t("modal.pure.title.error"))
      return false;
    } finally {
      this.setState({ loading: false });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for send a reset password email to an user registered in hibou.legal
   * @date 16-08-2021
   * @status no delete
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleResetPassword = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    let { resetEmail } = this.state;

    resetEmail = resetEmail.trim();
    resetEmail = resetEmail.toLowerCase()

    if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(resetEmail)) {
      this.modalUtil.showModal('error', this.props.t("login.action.errorLossEmail"), this.props.t("modal.pure.title.error"))
      this.setState({ loading: false });
      return false;
    }

    try {
      let sessionChangePassword = await this.sessionService.sessionChangePassword(resetEmail);
      if (Number(sessionChangePassword.statusCode) === 200) {
        this.setState({ templateRendering: "login" });
        this.modalUtil.showModal('success', this.props.t("login.action.successSendEmail"), this.props.t("modal.pure.title.success"))
      }
    } catch (err) {
      console.log(err);
      this.modalUtil.showModal('error', this.props.t("login.action.errorChangePass"), this.props.t("modal.pure.title.error"))
    } finally {
      this.setState({ loading: false });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for register a new user in hibou.legal
   * @updatedDate 29-04-2022
   * @status no delete
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleSignUp = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    let { newEmail, newPassword, repeatNewPassword } = this.state;

    newEmail = newEmail.trim();
    newPassword = newPassword.trim();
    repeatNewPassword = repeatNewPassword.trim();

    newEmail = newEmail.toLowerCase();

    if (newPassword === "" || newPassword.length <= 0) {
      this.modalUtil.showModal('error', this.props.t("login.action.errorSignUpPassword"), this.props.t("modal.pure.title.error"))
      this.setState({ loading: false });
      return false;
    }

    if (repeatNewPassword === "" || repeatNewPassword.length <= 0) {
      this.modalUtil.showModal('error', this.props.t("login.action.errorSignUpPassword"), this.props.t("modal.pure.title.error"))
      this.setState({ loading: false });
      return false;
    }

    if (
      newPassword.length < Number(process.env.REACT_APP_PASSWORD_LENGTH) ||
      repeatNewPassword.length < Number(process.env.REACT_APP_PASSWORD_LENGTH)
    ) {
      this.modalUtil.showModal('error', this.props.t("login.action.errorPassLength"), this.props.t("modal.pure.title.error"))
      this.setState({ loading: false });
      return false;
    }

    if (!(newPassword === repeatNewPassword)) {
      this.modalUtil.showModal('error', this.props.t("login.action.errorPass"), this.props.t("modal.pure.title.error"))
      this.setState({ loading: false });
      return false;
    }

    {/* Logic or when everything is satisfied for registration process */ }
    try {
      let sessionRegisterUser = await this.sessionService.sessionRegister(
        newEmail,
        newPassword
      );

      if (Number(sessionRegisterUser.statusCode) === 200) {
        this.localStorageService.setLocalStorageItem("token", sessionRegisterUser.data);
        return window.location.reload();
      }
    } catch (err) {
      console.log(err);
      this.modalUtil.showModal('error', this.props.t("login.action.errorSignUpDefault"), this.props.t("modal.pure.title.error"))
      this.setState({ loading: false });
      return false;
    } finally {
      this.setState({ loading: false });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for capture the information in all inputs
   * @date 16-11-2020
   * @status no delete
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for change the form in the login card
   * @date 16-11-2020
   * @status no delete
   * @param {String} template
   * @memberof LoginAction
   */
  onHandleSelectTemplate = (template) => {
    switch (template) {
      case "login":
        this.setState({
          templateRendering: "login",
          errorForm: false,
          loginSelected: "login-button-signin-signup-selected",
          registerSelected: "",
        });
        break;
      case "register":
        this.setState({
          templateRendering: "register",
          errorForm: false,
          loginSelected: "",
          registerSelected: "login-button-signin-signup-selected",
        });
        break;
      case "forgotPassword":
        this.setState({
          templateRendering: "forgotPassword",
          errorForm: false,
        });
        break;
      default:
        break;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the label error
   * @date 16-11-2020
   * @status no delete
   * @memberof LoginAction
   */
  onHandleHideError = () => {
    this.setState({
      errorForm: false,
      errorMessage: "",
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the label success
   * @date 16-11-2020
   * @status no delete
   * @memberof LoginAction
   */
  onHandleHideSuccess = () => {
    this.setState({
      successForm: false,
      successMessage: "",
    });
  };

  /**
   * @author Adrian Montemayor
   * @description Handler method to run when they press the button "Enter"
   * @date 21-11-2020
   * @status no delete
   * @memberof LoginAction
   */
  onHandleSignUpKeypress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onHandleSignUp(e);
    }
  };


  /**
   * @description Executes handleLogin functionality when "Enter" key is hit
   * @status no delete
   * @param {*} e
   * @memberof LoginAction
   */
  onHandleLoginKeypress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onHandleLogin(e);
    }
  };


  /**
   * @description Executes Reset Password functionality when "Enter" key is pressed.
   * @status no delete
   * @param {*} e
   * @memberof LoginAction
   */
  onHandleResetPasswordKeypress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onHandleResetPassword(e);
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the password icon and text in Login form
   * @date 16-11-2020
   * @status no delete
   * @memberof LoginAction
   */
  onHandleShowPassword = () => {
    let { loginShowPasswordIcon } = this.state;
    let inputPassword = document.querySelector("#password");

    if (
      loginShowPasswordIcon === "login-input-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        loginShowPasswordIcon: "login-input-show-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        loginShowPasswordIcon: "login-input-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the newPassword icon and text in Register form
   * @date 16-11-2020
   * @status no delete
   * @memberof LoginAction
   */
  onHandleShowPasswordRegister = () => {
    let { loginShowPasswordRegisterIcon } = this.state;
    let inputPassword = document.querySelector("#newPassword");

    if (
      loginShowPasswordRegisterIcon ===
      "login-input-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        loginShowPasswordRegisterIcon: "login-input-show-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        loginShowPasswordRegisterIcon:
          "login-input-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the repeatPassword icon and text in Register form
   * @date 16-11-2020
   * @status no delete
   * @memberof LoginAction
   */
  onHandleShowPasswordRepeatRegister = () => {
    let { loginShowPasswordRepeatRegisterIcon } = this.state;
    let inputPassword = document.querySelector("#repeatNewPassword");

    if (
      loginShowPasswordRepeatRegisterIcon ===
      "login-input-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        loginShowPasswordRepeatRegisterIcon:
          "login-input-show-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        loginShowPasswordRepeatRegisterIcon:
          "login-input-show-password-icon-desactive",
      });
    }
  };

  render() {
    return (
      <LoginView
        {...this.state}
        onHandleLogin={this.onHandleLogin}
        onHandleResetPassword={this.onHandleResetPassword}
        onHandleSignUp={this.onHandleSignUp}
        onHandleSelectTemplate={this.onHandleSelectTemplate}
        onHandleGeneralChange={this.onHandleGeneralChange}
        onHandleSignUpKeypress={this.onHandleSignUpKeypress}
        onHandleLoginKeypress={this.onHandleLoginKeypress}
        onHandleResetPasswordKeypress={this.onHandleResetPasswordKeypress}
        onHandleHideError={this.onHandleHideError}
        onHandleHideSuccess={this.onHandleHideSuccess}
        onHandleShowPassword={this.onHandleShowPassword}
        onHandleShowPasswordRegister={this.onHandleShowPasswordRegister}
        onHandleShowPasswordRepeatRegister={this.onHandleShowPasswordRepeatRegister}
      />
    );
  }
}


/**
 * @description Container for the LoginAction Component.
 * @param {*} props
 * @return {React.JSX.Element}
 * @status no delete
 */
function LoginActionContainer(props) {
  const { t } = useTranslation();
  return <LoginAction {...props} t={t} />;
}

export { LoginActionContainer as default };
